'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { RETURN_ORDER_TYPES } from 'shipping-and-returns/constants/returnOrderTypes'
import { AccordionTitle } from 'shipping-and-returns/containers/ReturnMethodsInfoContainer/components/AccordionTitle/AccordionTitle'

interface StoreTitleProps {
	readonly isFree: boolean
	readonly orderType?: string
	readonly price: string
}
export function StoreTitle({ isFree, orderType, price }: StoreTitleProps) {
	const { t } = useLabels()

	return (
		<AccordionTitle
			data-testid='myPurchases.online.details.returns.store'
			title={t('myPurchases.online.details.returns.store.title')}
			hasEcoContent={orderType !== RETURN_ORDER_TYPES.STORE}
			isFree={isFree}
			cost={price}
		/>
	)
}
